import React, { useEffect, useState } from "react";
import "./Listing.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Listing = () => {
  const [residentialListings, setResidentialListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const startTime = Date.now();

    const fetchListings = async () => {
      try {
        const response = await fetch(
          "https://t3yaaqetsktr267ko4xucsactu0wdogd.lambda-url.us-east-2.on.aws/",
          {
            headers: { "x-custom-key": "crazySecretKey82183b48921$@^JNF@!" },
          }
        );

        const data = await response.json();

        let allListings = [];
        if (Array.isArray(data)) {
          allListings = data;
        } else if (data.listings && Array.isArray(data.listings)) {
          allListings = data.listings;
        }

        const onlyResidential = allListings.filter(
          (l) =>
            l.Unit?.Description?.startsWith("Residential:") ||
            l.Property?.StructureDescription?.startsWith("Residential:")
        );

        setResidentialListings([...onlyResidential].reverse());

        const elapsed = Date.now() - startTime;
        const remaining = 2000 - elapsed;

        if (remaining > 0) {
          setTimeout(() => setLoading(false), remaining);
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching listings:", error);
        setResidentialListings([]);

        const elapsed = Date.now() - startTime;
        const remaining = 2000 - elapsed;

        if (remaining > 0) {
          setTimeout(() => setLoading(false), remaining);
        } else {
          setLoading(false);
        }
      }
    };

    fetchListings();
  }, []);

  const cleanDescription = (desc = "") =>
    desc.replace(/^Residential:/, "").trim() || "N/A";

  const getListingId = (listing) => {
    const rentalUrl = listing.RentalApplicationUrl || "";
    const queryString = rentalUrl.split("?")[1] || "";
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get("listingId");
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Helmet>
          <title>For Rent Residential Properties | Harrisburg, PA</title>
          <meta
            name="description"
            content="Residential Properties in the Harrisburg Pennsylvania Area."
          />
          <link
            rel="canonical"
            href="https://www.deltapmg.com/residential-listings"
          />
          <meta
            property="og:title"
            content="For Rent Residential Properties | Harrisburg, PA"
          />
          <meta
            property="og:description"
            content="Residential Properties in the Harrisburg Pennsylvania Area."
          />
          <meta
            property="og:url"
            content="https://www.deltapmg.com/residential-listings"
          />
          <meta property="og:type" content="website" />
        </Helmet>

        <div className="loading-content">
          <div className="loading-spinner-wrapper">
            <div className="loading-spinner"></div>
            <div className="loading-pulse"></div>
          </div>
          <h2 className="loading-title">Loading Listings...</h2>
          <p className="loading-subtitle">Fetching available properties</p>
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="listing-container">
      <Helmet>
        <title>For Rent Residential Properties | Harrisburg, PA</title>
        <meta
          name="description"
          content="Residential Properties in the Harrisburg Pennsylvania Area."
        />
        <link
          rel="canonical"
          href="https://www.deltapmg.com/residential-listings"
        />
        <meta
          property="og:title"
          content="For Rent Residential Properties | Harrisburg, PA"
        />
        <meta
          property="og:description"
          content="Residential Properties in the Harrisburg Pennsylvania Area."
        />
        <meta
          property="og:url"
          content="https://www.deltapmg.com/residential-listings"
        />
        <meta property="og:type" content="website" />
      </Helmet>

      {residentialListings.length === 0 ? (
        <>
          <p className="no-listings-1">Currently Fully Leased — New Units Added Weekly</p>

          <div className="listing-preference-cta">
            <a
              href="/listing-preferences"
              className="listing-preference-btn"
            >
              Submit Rental Preferences
            </a>
          </div>
        </>
      ) : (
        <>
          <div className="listing-title-wrapper">
            <h1 className="listing-title-1">Residential Listings</h1>
          </div>

          {residentialListings.map((listing, index) => {
            const unit = listing.Unit || {};
            const property = listing.Property || {};

            const image =
              unit.Files?.find((f) => f.Type === "Image")?.Url ||
              property.Files?.find((f) => f.Type === "Image")?.Url ||
              "https://via.placeholder.com/600x400?text=No+Image";

            const address = `${unit.Address?.AddressLine1 || property.Address?.AddressLine1 || ""}, ${
              unit.Address?.City || property.Address?.City || ""
            }, ${unit.Address?.State || property.Address?.State || ""} ${
              unit.Address?.PostalCode || property.Address?.PostalCode || ""
            }`;

            const listingId = getListingId(listing);

            return (
              <Link
                key={index}
                to={`/residential-listings/${listingId}`}
                state={{ listing }}
                className="listing-card-link"
              >
                <div className="listing-card" style={{ cursor: "pointer" }}>
                  <div className="listing-image">
                    <img src={image} alt={address || "Property"} />
                  </div>

                  <div className="listing-details">
                    <h3>{address}</h3>
                    <p>
                      <strong>Sqft:</strong> {unit.UnitSize || "N/A"}
                    </p>
                    <p className="listing-description">
                      <strong>Description:</strong>{" "}
                      {cleanDescription(unit.Description) ||
                        cleanDescription(property.StructureDescription)}
                    </p>
                    <p>
                      <strong>Price:</strong> ${listing.Rent || "N/A"}
                    </p>
                    <p>
                      <strong>Available Date:</strong>{" "}
                      {listing.AvailableDate || "N/A"}
                    </p>
                  </div>
                </div>
              </Link>
            );
          })}

          <div className="listing-preference-cta">
            <h2>Didn&apos;t find what you are looking for?</h2>
            <a
              href="/listing-preferences"
              className="listing-preference-btn"
            >
              Submit Rental Preferences
            </a>
          </div>
        </>
      )}
    </div>
  );
};

export default Listing;